import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowSplitLeft"><Path d="M9.5 3.5H3.5V9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 14.5V20.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 12H20.5M12 12L4 4M12 12L4 20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowSplitLeft;
